import React, { useEffect } from "react";
import "./Monetization.scss";
import Select from "react-select";
import StatisticTable from "../../../../components/StatisticTable/StatisticTable";
import {
  columnsRFQCSV,
  customStylesSelect,
  loaderOverride,
  totalsRanges,
} from "../../../../utils/constants/constants";
import MonetizationLegend from "../../../../components/MonetizationLegend/MonetizationLegend";
import MonetizationItem from "../../../../components/MonetizationItem/MonetizationItem";
import TotalRangePicker from "../../../../components/TotalRangePicker/TotalRangePicker";
import useTableContent from "./hooks/useTableContent";
import { MoonLoader } from "react-spinners";
import useMonetization from "./hooks/useMonetization";
import CsvDownloader from "react-csv-downloader";

const Monetization = () => {
  const {
    filterTypeSaved,
    fromSaved,
    toSaved,
    fromDate,
    toDate,
    isLoaded,
    selectorValue,
    isLoading,
    pureData,
    balancesData,
    data,
    showRangePicker,
    setSelectorValue,
    getMonetizationData,
    setIsLoaded,
    setShowRangePicker,
    getDateRange,
    setFromDate,
    setToDate,
    getTBCTableCSV,
  } = useMonetization();

  const { RFQTable, withdrawTable, totalTable } = useTableContent(
    pureData,
    balancesData,
  );

  useEffect(() => {
    if (filterTypeSaved && filterTypeSaved !== "null") {
      setSelectorValue(filterTypeSaved);
      getMonetizationData(fromSaved, toSaved);
    } else if (filterTypeSaved === "null" && fromSaved) {
      setSelectorValue("customized");
      getMonetizationData(fromSaved, toSaved);
    } else {
      getMonetizationData(fromDate, toDate);
    }
    setIsLoaded(true);
  }, []);

  useEffect(() => {
    if (isLoaded) {
      if (selectorValue === "customized") {
        setSelectorValue("customized");
        return setShowRangePicker(true);
      }

      if (selectorValue) {
        const range = getDateRange(selectorValue);
        getMonetizationData(range.startDate, range.endDate);
      }
    }
  }, [selectorValue]);

  if (isLoading) {
    return (
      <div className="monetiz__loader">
        <MoonLoader
          color="#7236CD"
          loading={isLoading}
          cssOverride={loaderOverride}
          size={35}
        />
      </div>
    );
  }
  return (
    <div className="monetiz__wrapper">
      <div className="monetiz__tables">
        <StatisticTable data={totalTable} />
        <StatisticTable data={RFQTable} />
        <StatisticTable data={withdrawTable} />
      </div>

      <div className="monetiz__selector-wrapper">
        <span className="monetiz__selector-label">Period</span>
        <div className="monetiz__controls">
          <Select
            styles={customStylesSelect}
            options={totalsRanges}
            placeholder={"placeholder"}
            getOptionValue={(option) => option.value}
            onChange={(option) => {
              if (
                option.value === "customized" &&
                selectorValue === "customized"
              ) {
                setShowRangePicker(true);
              }

              setSelectorValue(option.value);
            }}
            value={totalsRanges.find(
              (option) => option.value === selectorValue,
            )}
          />
          <CsvDownloader
            className="monetiz__download"
            filename="TBC Stat"
            extension=".csv"
            separator=";"
            wrapColumnChar=""
            columns={columnsRFQCSV}
            datas={() => getTBCTableCSV(fromDate, toDate)}
          >
            <span>Download TBC Stat</span>
          </CsvDownloader>
        </div>
      </div>
      <div className="monetiz__items-table">
        <MonetizationLegend />
        {data?.map((el) => (
          <MonetizationItem
            el={el}
            balancesData={balancesData}
            key={el?.transactions?.[0]?.created}
          />
        ))}
      </div>
      {showRangePicker && (
        <TotalRangePicker
          showModal={showRangePicker}
          setShowModal={setShowRangePicker}
          getData={getMonetizationData}
          setFromDate={setFromDate}
          setToDate={setToDate}
          fromDate={fromDate}
          toDate={toDate}
        />
      )}
    </div>
  );
};

export default Monetization;
